import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row modal-option-modify" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ticket_option_form = _resolveComponent("ticket-option-form")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "button-style": "secondary",
    "modal-size": "modal-lg"
  }, {
    button: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
    ]))]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "col-12",
          id: `ticket-list-${_ctx.uniqueId}`
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex align-items-center px-3", 'bg-secondary text-white'])
          }, [
            _createElementVNode("h5", {
              class: _normalizeClass(["border-0", 'text-start'])
            }, [
              _cache[3] || (_cache[3] = _createTextVNode("Modificar opcion: ", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.option.name), 1)
            ]),
            _createElementVNode("button", {
              "data-bs-toggle": "tooltip",
              "data-bs-title": "Reestablecer",
              class: "btn btn-outline-light ms-auto",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args))),
              disabled: !_ctx.editing
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
            ]))], 8, _hoisted_3),
            _createElementVNode("button", {
              "data-bs-toggle": "tooltip",
              "data-bs-title": "Guardar cambios",
              class: "btn btn-primary ms-2 me-5",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args))),
              disabled: !_ctx.editing
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fas fa-save" }, null, -1)
            ]))], 8, _hoisted_4)
          ]),
          _createVNode(_component_ticket_option_form, {
            ref: "ticketOptionForm",
            option: _ctx.option,
            options: _ctx.options,
            id: _ctx.uniqueId,
            onModifying: _ctx.modifying,
            event: _ctx.event
          }, null, 8, ["option", "options", "id", "onModifying", "event"])
        ], 8, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}